import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Instuction"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M12.104 17.8711L13.3723 10.8953L11.8965 10.627L10.6282 17.6028L12.104 17.8711Z" }, null, -1);
const _hoisted_3 = /* @__PURE__ */ _createElementVNode("path", { d: "M15.4036 10.4424L18.9798 13.4225C19.1416 13.5574 19.2393 13.7542 19.2489 13.9647C19.2584 14.1752 19.179 14.38 19.03 14.529L15.4996 18.0593L14.439 16.9987L17.3886 14.0491L14.4433 11.5947L15.4036 10.4424Z" }, null, -1);
const _hoisted_4 = /* @__PURE__ */ _createElementVNode("path", { d: "M6.61082 14.0491L9.55606 11.5947L8.59578 10.4424L5.01962 13.4225C4.85774 13.5574 4.76008 13.7542 4.75053 13.9647C4.74098 14.1752 4.82042 14.38 4.96943 14.529L8.49976 18.0593L9.56042 16.9987L6.61082 14.0491Z" }, null, -1);
const _hoisted_5 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.24951 5V19C1.24951 19.9665 2.03301 20.75 2.99951 20.75H20.9995C21.966 20.75 22.7495 19.9665 22.7495 19V5C22.7495 4.0335 21.966 3.25 20.9995 3.25H2.99951C2.03301 3.25 1.24951 4.0335 1.24951 5ZM2.99951 4.75C2.86144 4.75 2.74951 4.86193 2.74951 5V7.25H21.2495V5C21.2495 4.86193 21.1376 4.75 20.9995 4.75H2.99951ZM21.2495 19V8.75H2.74951V19C2.74951 19.1381 2.86144 19.25 2.99951 19.25H20.9995C21.1376 19.25 21.2495 19.1381 21.2495 19Z"
}, null, -1);
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_6);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Instuction.vue"]]);
